module.exports = __webpack_public_path__ + "img/roles_4.329223af.png";